import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=592f5c40&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=592f5c40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f5c40",
  null
  
)

export default component.exports